var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "dates" }, [
    _c("div", { staticClass: "flex-row flex-3" }, [
      _c("div", { staticClass: "flex-col flex-2" }, [
        _c("div", { staticClass: "flex-row flex-1" }, [
          _c(
            "div",
            {
              staticClass:
                "flex-col flex-1 label flex-justify-center pb-1 pl-1 pt-1 pr-1",
            },
            [_vm._v(_vm._s(_vm.$t("nextMajorOutage")) + ":")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-col flex-1 flex-justify-center pb-1 pl-1 pt-1 pr-1",
              attrs: { id: "nextMajorOutagesValue1" },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.datesGeneralStrategyobj.nextMajorOutagesValue1) +
                  " "
              ),
            ]
          ),
        ]),
        _c("div", { staticClass: "flex-row flex-1" }, [
          _c(
            "div",
            {
              staticClass:
                "flex-col flex-1 label flex-justify-center pb-1 pl-1 pt-1 pr-1",
            },
            [_vm._v(_vm._s(_vm.$t("eolTechnical")) + ":")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-col flex-1 pb-1 flex-justify-center pl-1 pt-1 pr-1",
              attrs: { id: "eolTechnicalValue" },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.datesGeneralStrategyobj.eolTechnicalValue) +
                  " "
              ),
            ]
          ),
        ]),
        _c("div", { staticClass: "flex-row flex-1" }, [
          _c(
            "div",
            {
              staticClass:
                "flex-col flex-1 label flex-justify-center pb-1 pl-1 pt-1 pr-1 mb-1",
            },
            [_vm._v(_vm._s(_vm.$t("expiryContracts")) + ":")]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex-col flex-1 flex-justify-center pb-1 pl-1 pt-1 pr-1 mb-1",
              attrs: { id: "expiryContractsValue" },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.datesGeneralStrategyobj.expiryContractsValue) +
                  " "
              ),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex-col flex-3" }, [
        _c(
          "div",
          {
            staticClass: "flex-row flex-1 pb-1 pl-1 pt-1 pr-1",
            attrs: { id: "nextMajorOutagesValue2" },
          },
          [
            _vm._v(
              " " +
                _vm._s(_vm.datesGeneralStrategyobj.nextMajorOutagesValue2) +
                " "
            ),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "flex-row flex-2 pb-1 pl-1 pt-1 pr-1 mb-1",
            attrs: { id: "dateCommentValue" },
          },
          [
            _vm._v(
              " " + _vm._s(_vm.datesGeneralStrategyobj.dateCommentValue) + " "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }